import React, {useState, useEffect, useRef} from 'react';
import ChapterBox from "./ChapterBox";
import {
    Box,
    Button,
    AppBar,
    Toolbar,
    Grid,
    Typography,
    Modal,
    LinearProgress,
    TextField,
    MenuItem, Select, Checkbox, FormControlLabel
} from '@mui/material';
import {Slide, Link, LinkEdit, HotEdit, Hot, Presentation} from '../services/types'
import {
    // addSlideToHot,
    // addSlideToLink,
    // createLink,
    // fetchProducts,
    // getLink,
    getSlide, updateProduct, updateSlide,
    // refreshSlide,
    // updateLink,
    // updateSlideHtml
} from '../services/api'
import LinkEditModal from './LinkEditModal';
import HotEditModal from './HotEditModal';
import AudioTimeline from './AudioTimeline';
import SingleRecordingEditor from "./SingleRecordingEditor";

interface SlideImage {
    id: string;
    url: string;
}

// interface AudioTrack {
//     id: string;
//     start: number;
//     duration: number;
//     audioUrl: string;
// }
// interface Product {
//     id: string;
//     name: string;
//     image_url: string;
// }
const SlideEditModal: React.FC<{
    slideId: number | null;
    onClose: () => void;
}> = ({slideId, onClose}) => {
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const [currentSlide, setCurrentSlide] = useState<Slide | null>(null)
    const [currentSlideLink, setCurrentSlideLink] = useState<string>("")
    const [slideVideo, setSlideVideo] = useState<string>("")

    const fetchSlideData = async () => {
        try {
            const data = await getSlide(slideId);
            setCurrentSlide(data)

            const svid = "https://stage.selfdetailing.ru"+data?.picture.raw
            var svid_url_arr = svid.split('screenshots')
            setSlideVideo(svid_url_arr[0] + 'screenshots/video.mp4')
            setCurrentSlideLink("https://stage.selfdetailing.ru"+data.presentation.slidesRoot+"/"+data.fileName)
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
        }
    };


    useEffect(() => {
        fetchSlideData();
    }, [slideId]);


    const handleSave = async () => {
        try {
            const updateData = {
                title: currentSlide?.title,
                description: currentSlide?.description,
                durationMs: currentSlide?.durationMs!!
            }
            await updateSlide(currentSlide?.id, updateData);
        } catch (error) {
            console.error('Error inviting team member:', error);
        }
    };
    return (
        <Box>
            <Box sx={{width: 'calc(100% - 348px)', height: '100%', position: 'absolute'}}>
                <iframe
                    ref={iframeRef}
                    src={currentSlideLink}
                    style={{ width: '100%', border: 'none', height: '100%', background: '#fff' }}
                    title={currentSlide?.title}
                />
            </Box>
            {currentSlide !== null && (
                <Box className='slideInfoEdit'>

                    <TextField
                        fullWidth
                        margin="normal"
                        label="Название"
                        value={currentSlide?.title}
                        onChange={(e) => {
                            if (currentSlide) {
                                setCurrentSlide({
                                    ...currentSlide,
                                    title: e.target.value
                                });
                            }
                        }}
                        multiline
                        rows={1}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Описание"
                        value={currentSlide?.description}
                        onChange={(e) => {
                            if (currentSlide) {
                                setCurrentSlide({
                                    ...currentSlide,
                                    description: e.target.value
                                });
                            }
                        }}
                        multiline
                        rows={4}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Длительность (секунд)"
                        type="number"
                        value={currentSlide?.durationMs/1000}
                        onChange={(e) => {
                            if (currentSlide) {
                                setCurrentSlide({
                                    ...currentSlide,
                                    durationMs: Number(e.target.value)*1000
                                });
                            }
                        }}
                    />

                    <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Button onClick={handleSave} variant="contained" sx={{mt: 2, background:'#3a485b'}}>
                            Сохранить
                        </Button>
                        <Button onClick={onClose} variant="contained" sx={{mt: 2, background:'rgba(58,72,91,0.09)'}}>
                            Закрыть
                        </Button>
                    </Box>
                    <a href={slideVideo} target="_blank" style={{textAlign: 'center', padding: 0, margin: '30px auto 0', position: 'relative', display: 'inline-block', borderBottom: '1px solid #000', borderRadius: 0}}>
                        Скачать видео
                    </a>
                    {/*<Button onClick={()=>setIsHotEditModalOpen(true)} variant="contained" sx={{mt: 2, width: "100%", background:' rgba(255, 0, 0, 1)'}}>*/}
                    {/*    Горячие слайды*/}
                    {/*</Button>*/}
                    {/*<Box sx={{display: 'flex'}}>*/}
                    {/*    <Button onClick={() => setRecordVideoOpen(true)} variant="contained" sx={{mt: 2, width: "100%", background:'#3a485b'}}>*/}
                    {/*        Записать видео*/}
                    {/*    </Button>*/}
                    {/*    <a href={"https://static.productscript.ru/uploads/webm/audio_"+slide?.id+".webm.mp4"} target="_blank">*/}
                    {/*        <Button variant="contained" sx={{mt: 2, width: "100%", background:'#1b6448'}}>*/}
                    {/*            Открыть*/}
                    {/*        </Button>*/}
                    {/*    </a>*/}
                    {/*</Box>*/}
                    {/*<Button onClick={handleRefreshSlide} variant="contained" sx={{mt: 2, left: '24px', width: "calc(100% - 48px)", position: 'absolute', bottom: '24px'}}>*/}
                    {/*    Обноваить код слайда*/}
                    {/*</Button>*/}

                </Box>
            )}


        </Box>
    );
};
export default SlideEditModal;
